class MeetTheCase {

  constructor(section) {

    this.section = section;

 this.state = {
  product:
    section.querySelector('.compare-item.active')?.dataset.product || '',
  mode: 'carry_on',
  tab: 'in_use'
};

    this.compareItems = [
    ...section.querySelectorAll('.compare-item')
    ];

    this.productPanels = [
    ...section.querySelectorAll('.case-panel')
    ];

    this.sidebarPanels = [
    ...section.querySelectorAll('.sidebar-panel')
    ];

    //this.sidebarPanels.forEach(panel => {
 // this.state.tabs[panel.dataset.product] = 'in_use';
//});

    this.bindEvents();

    this.renderProduct();

  }

  bindEvents() {

    /* Compare */

    this.section
      .querySelector('.compare-items')
      .addEventListener('click', (event) => {

        const button =
          event.target.closest('.compare-item');

        if (!button) return;

        this.compareItems.forEach(item =>
          item.classList.remove('active')
        );

        button.classList.add('active');

        this.state.product =
          button.dataset.product;

        this.renderProduct();

      });

    /* Sidebar */

    this.section.addEventListener('click', (event) => {

  /* Carry / Check */
  const toggle = event.target.closest('.where-fits-toggle button');

  if (toggle) {

    this.state.mode = toggle.dataset.mode;

    this.renderWhereFits();

    return;

  }

  const activeSidebar = event.target.closest('.sidebar-panel.active');

  if (!activeSidebar) return;

  /* Mobile Tabs */

  const mobileTab = event.target.closest('.meet-case-mobile-tab');

  if (mobileTab) {

   this.state.tab = mobileTab.dataset.tab;

    this.renderTab();

    return;

  }

  /* Accordion */

  const header = event.target.closest('.accordion-header');

  if (header) {

    const item = header.closest('.accordion-item');

    this.state.tab = item.dataset.tab;

    this.renderTab();

    return;

  }

  /* Read More */

  const readMore = event.target.closest('.read-more');

  if (readMore) {

    const wrapper = readMore.closest('.accordion-content');

    wrapper.classList.toggle('expanded');

  }
  
});
/* Mobile Product Dropdown */

const mobileProducts = this.section.querySelector(
  '.meet-case-mobile-products'
);

if (mobileProducts) {

  const trigger = mobileProducts.querySelector(
    '.meet-case-mobile-trigger'
  );

  const current = mobileProducts.querySelector(
    '.mobile-product-current'
  );

  const options = mobileProducts.querySelectorAll(
    '.meet-case-mobile-option'
  );

  /* Open / Close */

  trigger.addEventListener('click', () => {

    mobileProducts.classList.toggle('open');

  });

  /* Select Product */

  options.forEach(option => {

    option.addEventListener('click', () => {

      this.state.product = option.dataset.product;

      /* Active Mobile Option */
    options.forEach(opt => {
      opt.classList.toggle(
        'active',
        opt.dataset.product === this.state.product
      );
    });

      /* Update Compare Buttons */

      this.compareItems.forEach(item => {

        item.classList.toggle(
          'active',
          item.dataset.product === this.state.product
        );

      });

      /* Update Trigger */

      current.innerHTML = option.innerHTML;

      /* Close Dropdown */

      mobileProducts.classList.remove('open');

      /* Render */

      this.renderProduct();

    });

  });

  /* Close when clicking outside */

  document.addEventListener('click', (event) => {

    if (!mobileProducts.contains(event.target)) {

      mobileProducts.classList.remove('open');

    }

  });

}
  }
 renderProduct() {

  this.productPanels.forEach(panel => {
    panel.classList.toggle(
      'active',
      panel.dataset.product === this.state.product
    );
  });

 this.sidebarPanels.forEach(panel => {
  panel.classList.toggle(
    'active',
    panel.dataset.product === this.state.product
  );
/* Sync Mobile Options */

const mobileOptions = this.section.querySelectorAll(
  '.meet-case-mobile-option'
);

mobileOptions.forEach(option => {
  option.classList.toggle(
    'active',
    option.dataset.product === this.state.product
  );
});

});

//setTimeout(() => {
  //this.renderTab();
//}, 0);
this.renderTab();
/* Sync Mobile Dropdown */

const mobileCurrent = this.section.querySelector(
  '.mobile-product-current'
);

const activeCompare = this.compareItems.find(item =>
  item.dataset.product === this.state.product
);

if (mobileCurrent && activeCompare) {
  mobileCurrent.innerHTML = activeCompare.innerHTML;
}
  this.renderTab();
    /* Where Fits */

if (this.state.tab === 'where_fits') {
  this.renderWhereFits();
}
}
renderWhereFits() {

  /* Active Product */

  const activeProductPanel = this.productPanels.find(panel =>
    panel.dataset.product === this.state.product
  );

  if (!activeProductPanel) return;

  /* Left Media */

  const wherePanel = activeProductPanel.querySelector(
    '.case-tab[data-tab="where_fits"]'
  );

  if (wherePanel) {

    wherePanel
      .querySelectorAll('.where-fits-panel')
      .forEach(panel => {

        panel.classList.toggle(
          'active',
          panel.dataset.mode === this.state.mode
        );

      });

    /* Mobile Toggle */

    wherePanel
      .querySelectorAll('.where-fits-toggle button')
      .forEach(button => {

        button.classList.toggle(
          'active',
          button.dataset.mode === this.state.mode
        );

      });

  }

  /* Active Sidebar */

  const activeSidebar = this.sidebarPanels.find(panel =>
    panel.dataset.product === this.state.product
  );

  if (!activeSidebar) return;

  /* Desktop Toggle */

  activeSidebar
    .querySelectorAll('.where-fits-toggle button')
    .forEach(button => {

      button.classList.toggle(
        'active',
        button.dataset.mode === this.state.mode
      );

    });

  /* Desktop Content */

  activeSidebar
    .querySelectorAll('.where-fits-copy')
    .forEach(copy => {

      copy.classList.toggle(
        'active',
        copy.dataset.mode === this.state.mode
      );

    });

}
renderTab() {

  /* Active Sidebar */
const activeTab = this.state.tab;
  const activeSidebar = this.sidebarPanels.find(panel =>
    panel.dataset.product === this.state.product
  );

  if (!activeSidebar) return;

  /* Sidebar Accordion */

  const items = activeSidebar.querySelectorAll('.accordion-item');

  items.forEach(item => {

    const active = item.dataset.tab === activeTab;

    item.classList.toggle('active', active);

    const content = item.querySelector('.accordion-content');

    if (content) {
      content.style.maxHeight = active
        ? content.scrollHeight + 'px'
        : '0px';
    }

    const icon = item.querySelector('.accordion-icon');

    if (icon) {
      icon.innerHTML = active
        ? window.iconMinus
        : window.iconPlus;
    }

  });

   /* Mobile Tabs */

  const mobileTabs = activeSidebar.querySelectorAll(
    '.meet-case-mobile-tab'
  );

  mobileTabs.forEach(tab => {

    tab.classList.toggle(
      'active',
      tab.dataset.tab === activeTab
    );

  });

  /* Left Media */

  const activeProductPanel = this.productPanels.find(panel =>
    panel.dataset.product === this.state.product
  );

  if (!activeProductPanel) return;

  activeProductPanel
    .querySelectorAll('.case-tab')
    .forEach(tab => {

      tab.classList.toggle(
        'active',
        tab.dataset.tab === activeTab
      );

    });
  /* Where Fits */

if (activeTab === 'where_fits') {
    this.renderWhereFits();
}

}
}
function initMeetTheCase() {

  document
    .querySelectorAll('.meet-case-section')
    .forEach(section => {

      if (section.meetCase) return;

      section.meetCase = new MeetTheCase(section);

    });

}

document.addEventListener(
  'DOMContentLoaded',
  initMeetTheCase
);

document.addEventListener(
  'shopify:section:load',
  initMeetTheCase
);